import { addBehaviorstatsModel } from '../model/store'
import { getScopeParam } from '../utils/session/store'
import { getLanguageStore } from '../utils/storage/language'
import { getMemberInfo, getMerchantInfoStore } from '../utils/storage/store'

import { getUrlHashName } from '../utils/page'


/**
 * 添加行为统计
 * @param {Object} params
 * @param {string} params.areaId - 区域ID
 * @param {string} params.storeId - 门店ID
 * @param {string} params.memberId - 会员ID
 * @param {string} params.language - 语言
 * @param {number} params.object - 对象ID   160000
 * @param {number} params.behaviorType - 行为类型 160100
 * @param {string} params.behavior - 行为 160103...
 * @param {string} params.value1 - 值1
 * @param {string} params.value2 - 值2
 * @param {string} params.value3 - 值3
 * @param {string} params.value4 - 值4
 */
export function addBehaviorsRecord({
    storeId = '',
    language = '',
    object = 160000,
    behaviorType,
    behavior,
    value1, value2, value3, value4,value5
}) {
    const { areaId = '', partner = '', area = '', name = '', chainStoreId } = getScopeParam() || {}
    const { memberId = '' } = getMemberInfo() || {}
    const merchantInfo = getMerchantInfoStore() || {}

    const hashName = getUrlHashName()
    const sStoreId = hashName === '#/home' ? chainStoreId : merchantInfo.storeId

    console.log(merchantInfo, '///////merchantInfo///////')


    addBehaviorstatsModel({
        areaId: areaId,
        storeId: storeId || sStoreId,
        memberId: memberId,
        language: language || getLanguageStore(),
        primaryCategoryId:object,
        secondaryCategoryId:behaviorType,
        leafCategoryId:behavior,
        value1,
        value2,
        value3,
        value4,
        value5,
    }).then(data => {
        console.log(data)
    }).catch(ex => {
        console.log(ex)
    })

}